<template>
  <div>
    <complete-loading
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="
        (!('totalRecords' in hoopsData) ||
          (hoopsData.totalRecords && hoopsData.totalRecords == 0)) &&
        pageLoader
      "
    ></complete-loading>
    <section
      class="ipbPopUp between-footer"
      id="singleHoop"
      :class="{ 'd-none': Object.keys(singleHoop).length == 0 }"
    >
      <div class="containerArea" v-if="Object.keys(singleHoop).length > 0">
        <div class="row showNewPop mb-4">
          <div class="col-12">
            <!--====================FULL NEWS SECTION POP=============================-->
            <div class="fullNewsSection show d-none">
              <div class="customPp">
                <button
                  @click.prevent="
                    singleHoop = {};
                    toDivElement(lastId);
                  "
                  type="button"
                  class="close d-flex align-items-center justify-content-center"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body-p whiteBG p-3">
                <h4 class="my-1" v-html="singleHoop.tags"></h4>
                <div class="date d-flex align-items-center ml-auto mb-2">
                  {{ dateFunction(singleHoop.created) }}
                </div>
                <div class="imgT d-inline-block my-3">
                  <figure class="pr-3">
                    <img :src="singleHoop.image_url" />
                  </figure>
                  <p class="pt-2 insight-detail-post" v-html="singleHoop.text"></p>
                </div>
                <span>{{ $t("marin_source") }}</span>
              </div>
            </div>
            <!--====================End FULL NEWS SECTION POP=============================-->
          </div>
        </div>
      </div>
    </section>
    <div
      class="whiteBG p-3 mb-4 AutoChartist insighrSection"
      v-show="Object.keys(singleHoop).length == 0"
    >
      <div class="mt-2">
        <div
          class="row"
          v-if="hoopsData.totalRecords && hoopsData.totalRecords > 0"
        >
          <div
            class="col-md-6 border-0 py-0 m-0"
            v-for="(list, index) in hoopsData.records"
            :id="'hoopsData' + index"
          >
            <div class="mb-4 pb-3 cardInsight">
              <div class="d-flex justify-content-between">
                <div class="thumbnail" v-if="list.image_url">
                  <img :src="list.image_url" class="card-img-top" />
                </div>
                <div class="insighrInner">
                  <!-- <div class="d-flex align-items-center justify-content-between ">
                                        <div class="title">
                                            <h5 class="card-title">{{list.tags}}</h5>
                                        </div>  
                                        <div class="colRight d-flex align-items-center">
                                            <div class="date d-flex align-items-center"> {{list.created  | moment("DD MMMM YYYY")}}</div>
                                        </div>
                                    </div> -->
                  <div
                    class="card-text"
                    @click.prevent="
                      singleHoop = list;
                      toDivElement('singleHoop');
                      lastId = 'hoopsData' + index;
                    "
                  >
                    <p class="card-text mb-0" :ref="'less' + index">
                      <span v-html="list.text.substring(0, 210) + '...'"></span
                      ><!-- <span class="showmore green" @click.prevent="detailDiv(index,'more')" v-if="list.text && list.text.length > 150">Show More</span> -->
                    </p>
                    <!-- <p class="card-text mb-0 hide" :ref="'more'+index"><span v-html="list.text"></span> <span class="showmore green" @click.prevent="detailDiv(index,'less')">Show Less</span> </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center p-5 customLoader" v-else-if="pageLoader">
          <h4>{{ $t("rb_plzWaitWhileProc") }}</h4>
        </div>
        <div class="col-12 noRecordFound" v-else-if="!pageLoader">
          <img
            src="../../../../static/fxView/images/search.svg"
            alt="no record found"
          />
          <p>{{ $t("edu_thereIsNoRecord") }}</p>
        </div>
        <div class="col-12">
          <div
            class="loadMore mt-4 mt-md-5 text-center"
            v-if="
              hoopsData.totalRecords &&
              hoopsData.totalRecords > 0 &&
              !pageLoader
            "
          >
            <a
              href="#"
              class="common_btn btn_xs"
              @click.prevent="loadmoreList()"
            >
              {{ $t("marin_loadmore") }}</a
            >
          </div>
          <div
            class="loadMore mt-4 mt-md-5 text-center"
            v-else-if="
              hoopsData.totalRecords && hoopsData.totalRecords > 0 && pageLoader
            "
          >
            <a href="#" class="common_btn btn_xs">
              {{ $t("marin_loadwait") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import moment from "moment";
export default {
  name: "Market-insight",
  mixins: [fxViewMixins],
  data() {
    return {
      pageLoader: false,
      singleHoop: {},
      lastId: "",
      pageLimit: "10",
      search: "",
      page: 1,
    };
  },
  methods: {
    dateFunction(getDate) {
      let last_seen_date = moment(getDate).fromNow();
      return last_seen_date;
    },
    toDivElement(id) {
      setTimeout(function () {
        // console.log('-----',id)
        var elmnt = document.getElementById(id);
        elmnt.scrollIntoView();
        document.getElementById(id).focus();
        var top = $(window).scrollTop();
        $(window).scrollTop(top - 60);
      }, 300);
    },
    loadmoreList() {
      //loading more data from api by increasing page number
      this.page = this.page + 1;
      this.listing();
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this },
      };
      this._runGetHoopsData(inputJson);
    },
  },
  created() {
    this.listing();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tradingtools/market_insight.vue